import { Link } from 'react-router-dom';
import { GLOBAL_LINKS_BAIXAR_APP, GLOBAL_LINKS_CADASTRE_ENTRAR, GLOBAL_LINKS_FEATURE_JOGOS_E_BENEFICIOS, GLOBAL_LINKS_FEATURE_LISTA_INTELIGENTE, GLOBAL_LINKS_FEATURE_MAPA_MERCADO } from '../global/links';

const featurePopups = [
    {
        id: 0,
        title: "Lista Inteligente",
        img: require('./img/listaCel.avif'),
        alt: "Ícone: Lista Inteligente",
        authMessage: (
            <>
                Para acessar ou criar a sua lista, <Link
                    to={GLOBAL_LINKS_BAIXAR_APP}
                    target="_blank"
                >Baixe o aplicativo</Link> ou <Link
                    to={GLOBAL_LINKS_CADASTRE_ENTRAR}
                >faça login</Link>
            </>
        ),
        memberMessage: (
            <Link to={GLOBAL_LINKS_FEATURE_LISTA_INTELIGENTE}>Veja agora</Link>
        ),
        content: (
            <>
                Cadastre seus produtos digitando, lendo o código de barras ou escaneando sua nota fiscal. Receba alertas quando algum item entrar em oferta pelo monitor de preços e use os filtros para descobrir as melhores rotas de compra e os maiores descontos e economize até 75% nas suas compras!
            </>
        )
    },
    {
        id: 1,
        title: "Geolocalização",
        img: require('./img/inicio2.avif'),
        alt: "Ícone: Geolocalização",
        authMessage: (
            <Link to={GLOBAL_LINKS_BAIXAR_APP} target='_blank'>Baixe o app</Link>
        ),
        memberMessage: (
            <Link to={GLOBAL_LINKS_BAIXAR_APP} target='_blank'>Baixe o app</Link>
        ),
        content: (
            <>
                Receba automaticamente as ofertas e encartes da sua região ao passar próximo a um mercado,
                tornando a descoberta de promoções mais práticas e conveniente conforme sua localização.
            </>
        )
    },
    {
        id: 2,
        title: "Mapa das Ofertas",
        img: require('./img/mapa1.avif'),
        alt: "Ícone: Mapa das Ofertas",
        authMessage: (
            <>
                Para acessar o mapa das ofertas, <Link
                    to={GLOBAL_LINKS_BAIXAR_APP}
                    target="_blank"
                >Baixe o aplicativo</Link> ou <Link
                    to={GLOBAL_LINKS_CADASTRE_ENTRAR}
                >faça login</Link>
            </>
        ),
        memberMessage: (
            <Link to={GLOBAL_LINKS_FEATURE_MAPA_MERCADO}>Veja agora</Link>
        ),
        content: (
            <>
                Veja todas as ofertas e promoções centralizadas de cada supermercado da sua região.
                Em datas comemorativas, o mapa ganhará visuais especiais com promoções temáticas.
            </>
        )
    },
    {
        id: 3,
        title: "Mural das Ofertas",
        img: require('./img/inicio.avif'),
        alt: "Ícone: Mural das Ofertas",
        authMessage: (
            <>
                Achou uma oferta e quer compartilhar? <Link
                    to={GLOBAL_LINKS_BAIXAR_APP}
                    target="_blank"
                >Baixe o aplicativo</Link> ou <Link
                    to={GLOBAL_LINKS_CADASTRE_ENTRAR}
                >faça login</Link> para acessar o mural completo por aqui.
            </>
        ),
        memberMessage: (
            <b onClick={() => {
                const element = document.getElementById('external_iframe_mural');
                if (element) {
                    const y = element.getBoundingClientRect().top + window.scrollY - 140; // tira 70px
                    window.scrollTo({ top: y, behavior: 'smooth' });
                }
            }}>Veja agora</b>
        ),
        content: (
            <>
                Enquanto o TooMe capta parceiros para futuramente oferecer ganhos reais,
                você já acumula pontos ao postar ofertas, que podem ser usados para consultas de preço
                e trocados por benefícios (quando disponíveis).
            </>
        )
    },
    {
        id: 5,
        title: "Jogos e Benefícios",
        img: require('./img/jogos.avif'),
        alt: "Ícone: Jogos e Benefícios",
        authMessage: (
            <>
                Para acessar os jogos e benefícions, <Link
                    to={GLOBAL_LINKS_BAIXAR_APP}
                    target="_blank"
                >Baixe o aplicativo</Link> ou <Link
                    to={GLOBAL_LINKS_CADASTRE_ENTRAR}
                >faça login</Link>
            </>
        ),
        memberMessage: (
            <Link to={GLOBAL_LINKS_FEATURE_JOGOS_E_BENEFICIOS}>Veja agora</Link>
        ),
        content: (
            <>

                Divirta-se com jogos educativos enquanto acumula vantagens.
                Em breve, programas de benefícios e cupons especiais estarão disponíveis para você economizar ainda mais.
            </>
        )
    }
];
export const MakeTooMeFeaturePopup = ({ isOpen, title, imgSrc, alt, children, onClose }) => {

    if (!isOpen) return null;

    return (
        <div className="popup-overlay">
            <div className="popup-box">
                <h1>{title}</h1>
                <div>
                    <img src={imgSrc} alt={alt} loading="lazy" />
                    <p>{children}</p>
                </div>
                <button className="popup-close" onClick={onClose}>Fechar</button>
            </div>
        </div>
    );
}

export const ViewTooMeFeaturePopup = ({
    isAuthenticated,
    featuresPopup,
    setFeaturesPopup
}) => {

    return featurePopups.map(popup => (
        <MakeTooMeFeaturePopup
            key={popup.id}
            isOpen={featuresPopup === popup.id}
            title={popup.title}
            imgSrc={popup.img}
            alt={popup.alt}
            onClose={() => setFeaturesPopup(-1)}
        >
            {isAuthenticated ? <b onClick={() => setFeaturesPopup(-1)}>{popup.memberMessage}</b> : popup.authMessage}
            <br /><br />
            {popup.content}
        </MakeTooMeFeaturePopup >
    ))

}